import { tickerItems } from "@/mocks/home";

export default function TopBar() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-primary-600 text-background-50">
      <div className="flex items-stretch">
        <div className="hidden shrink-0 items-center gap-2 bg-primary-800 px-4 py-2 text-xs font-medium tracking-wide sm:flex">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400" />
          站内播报
        </div>
        <div className="relative flex-1 overflow-hidden py-2">
          <div className="flex w-max animate-marquee items-center">
            {doubled.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="mx-6 flex items-center gap-2 whitespace-nowrap text-xs text-background-50/90"
              >
                <i className="ri-bookmark-3-line text-accent-300" />
                {item}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden shrink-0 items-center gap-4 px-4 text-xs text-background-50/85 md:flex">
          <a href="#guide" className="cursor-pointer transition hover:text-accent-200">
            使用指引
          </a>
          <a href="#faq" className="cursor-pointer transition hover:text-accent-200">
            常见问题
          </a>
        </div>
      </div>
    </div>
  );
}